import { createContext, useContext } from "react";
import getToken from "../hooks/getToken";
import axios from "axios";
import { useLanguage } from "../store/language-context";
import { useQuery } from "@tanstack/react-query";

export const UserDataContext = createContext();

export const UserDataProvider = ({ children }) => {
    const token = getToken();
    const { URL } = useLanguage();

    const { data: profile, error, isLoading: loading, refetch } = useQuery({
        queryKey: ['user-profile', URL, token],
        queryFn: async () => {
            const response = await axios.get(`${URL}/profile`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            if (response.status !== 200) throw new Error('حدث خطأ ما برجاء المحاولة مره أخرى');
            return response?.data?.data?.data ?? response?.data?.data;
        },
        retry: 1,
        refetchOnMount: false,
        refetchOnReconnect: false,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 60,
        cacheTime: 1000 * 60 * 60
    });

    return (
        <UserDataContext.Provider value={{ profile, error, loading, refetch }}>
            {children}
        </UserDataContext.Provider>
    );
};

export const useUserData = () => useContext(UserDataContext);
